import { IS_ME_LINK } from "@/constants/app";

export const LOCALE_PARAM = "locale";
export const ID_PARAM = "id";
export const TYPE = "type";

export const LEGACY_ENTRY_ROUTE = `/:${LOCALE_PARAM}?/entry` as const;
export const QR_ENTRY_ROUTE = `/:${LOCALE_PARAM}?/my-qr-codes` as const;
export const LINK_ENTRY_ROUTE = `/:${LOCALE_PARAM}?/my-links` as const;

export const LEGACY_ARCHIVE_ROUTE = `/:${LOCALE_PARAM}?/archive` as const;
export const QR_ARCHIVE_ROUTE = `/:${LOCALE_PARAM}?/archived-qr-codes` as const;
export const LINK_ARCHIVE_ROUTE = `/:${LOCALE_PARAM}?/archived-links` as const;

export const LEGACY_REFERRER_ROUTE = `/:${LOCALE_PARAM}?/referrer` as const;
export const QR_REFERRER_ROUTE = `/:${LOCALE_PARAM}?/refer-and-earn` as const;

export const ROUTES = {
  ENTRY: IS_ME_LINK ? LINK_ENTRY_ROUTE : QR_ENTRY_ROUTE,
  ARCHIVE: IS_ME_LINK ? LINK_ARCHIVE_ROUTE : QR_ARCHIVE_ROUTE,
  ENTRY_CHANGE_OWNER: `/:${LOCALE_PARAM}?/entry/change-owner`,
  FOLDER_CHANGE_OWNER: `/:${LOCALE_PARAM}?/folder/change-owner`,
  SHARE_FOLDER_ACCESS: `/:${LOCALE_PARAM}?/folder/share`,
  CSV_IMPORT: `/:${LOCALE_PARAM}?/csv-import`,
  BULK_URL_SHORTENER: `/:${LOCALE_PARAM}?/bulk-url-shortener`,
  DOMAIN: `/:${LOCALE_PARAM}?/domain`,
  FAQ: `/:${LOCALE_PARAM}?/faq`,
  QR_CODE_GENERATOR: `/:${LOCALE_PARAM}?/qr-code-generator?from=admin`,
  INTEGRATION: `/:${LOCALE_PARAM}?/integration`,
  PROFILE: `/:${LOCALE_PARAM}?/profile`,
  REFERRER: QR_REFERRER_ROUTE,
  STATISTICS: `/:${LOCALE_PARAM}?/statistics`,
  STATISTICS_ID: `/:${LOCALE_PARAM}?/statistics/:${ID_PARAM}`,
  SUBSCRIPTION: `/:${LOCALE_PARAM}?/subscription`,
  SUPPORT: `/:${LOCALE_PARAM}?/support`,
  TEST: `/:${LOCALE_PARAM}?/test`,
  ENTRY_SETTINGS: `/:${LOCALE_PARAM}?/entry/settings`,
  FOLDER_SETTINGS: `/:${LOCALE_PARAM}?/folder/settings`,
} as const;

export const EXTERNAL_ROUTES = {
  HOME: `/:${LOCALE_PARAM}?`,
  PRICING_TABLE: `/:${LOCALE_PARAM}?/pricing#pricing-table`,
  EDIT_CODE_DESIGN: `/:${LOCALE_PARAM}?/entry/:${ID_PARAM}`,
  EDIT_CONTENT: `/:${LOCALE_PARAM}?/qr-code-generator/:${TYPE}/:${ID_PARAM}/edit`,
  OLD_ADMIN_SEARCH_USER: `/:${LOCALE_PARAM}?/user/search`,
  SWITCH_USER_EXIT: `/:${LOCALE_PARAM}?/user/search`,
} as const;
